const normalizeSiteUrl = (url: string) => url.replace(/\/$/, "");

export const SITE_URL = normalizeSiteUrl(
  process.env.REACT_APP_SITE_URL ?? "https://www.rotoinfissioni.it",
);

export const SITE_NAME = "Rotoinfissioni";

export const absoluteUrl = (path: string) =>
  `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

export const DEFAULT_OG_IMAGE = absoluteUrl("/favicon-bgk.png");
